import type { ReactNode } from 'react';
import styles from './Card.module.css';
import clsx from './clsx';

interface CardProps {
  children: ReactNode;
  className?: string;
  /** Renders as a <button> instead of a <div> for tappable rows (jobs list,
   *  the "pick up with Meira" continue card). */
  as?: 'div' | 'button';
  onClick?: () => void;
  /** LANE STORY-TOUR: an optional `data-tour` anchor id, passed through
   *  verbatim so the guided coach tour (components/CoachMark.tsx) can
   *  highlight a REAL Card in place — e.g. Home's story-score card — without
   *  any caller needing to reach past this component to attach the
   *  attribute itself. Additive/optional: every existing Card call site is
   *  unaffected (undefined renders no attribute at all). */
  tourAnchor?: string;
}

/** The recurring surf-background, hairline-border, shadow card used across
 *  every screen (story card, stat trio, job rows, the threads card, etc). */
export function Card({ children, className, as = 'div', onClick, tourAnchor }: CardProps) {
  const cls = clsx(styles.card, className);
  if (as === 'button') {
    return (
      <button type="button" className={cls} onClick={onClick} data-tour={tourAnchor}>
        {children}
      </button>
    );
  }
  return (
    <div className={cls} data-tour={tourAnchor}>
      {children}
    </div>
  );
}
